/* eslint-disable func-names */

export default function(headerStartTime, headerEndTime, timedHeaderClass, rootElement) {
  const date = new Date();
  const todaysTimestamp = date.getTime();
  if (headerStartTime < todaysTimestamp && todaysTimestamp < headerEndTime) {
    rootElement.classList.add(timedHeaderClass);
    const isDE = Boolean(document.querySelector('html:lang(de)'));
    if (isDE) {
      isDEAddDivs(rootElement);
    }
  }
}

function isDEAddDivs(rootElement) {
  const mainSnow = document.createElement('div');
  mainSnow.className = 'sdc-site-header--weihnachten__snow';
  rootElement.appendChild(mainSnow);
  mainSnow.innerHTML = '<div></div><div></div><div></div><div></div>';
}
